import { PersonalizedProductGroup } from "./personalizedProducts.types";

export interface PersonalizedProductsState {
  groups: PersonalizedProductGroup[];
  status: "idle" | "loading" | "success" | "error";
  error: string | null;
}

export const initialPersonalizedProductsState: PersonalizedProductsState = {
  groups: [],
  status: "idle",
  error: null,
};